document.addEventListener('DOMContentLoaded', () => {
  const zipInput   = document.getElementById('cart-zip');
  const calcBtn    = document.getElementById('cart-calc-btn');
  const resultsBox = document.getElementById('cart-shipping-results');

  zipInput.addEventListener('input', () => {
    let clean = zipInput.value.replace(/\D/g, '');
    if (clean.length > 9) clean = clean.slice(0, 9);
    zipInput.value = clean;
    calcBtn.disabled = clean.length < 5;
  });

  calcBtn.addEventListener('click', async () => {
    let zipRaw = zipInput.value;
    if (zipRaw.length < 5) return;

    const zip5 = zipRaw.slice(0, 5);

    resultsBox.innerHTML = '<p class="loading">Looking up ZIP code…</p>';

    let stateAbbrev;
    try {
      const zippopotamRes = await fetch(`https://api.zippopotam.us/us/${zip5}`);
      if (!zippopotamRes.ok) {
        if (zippopotamRes.status === 404) throw new Error('ZIP code not found');
        throw new Error(`Lookup failed: HTTP ${zippopotamRes.status}`);
      }
      const zipData = await zippopotamRes.json();
      const place = zipData.places && zipData.places[0];
      if (!place || !place["state abbreviation"]) {
        throw new Error('Could not determine state from ZIP');
      }
      stateAbbrev = place["state abbreviation"]; // ex: "CA", "NY"
    } catch (err) {
      resultsBox.innerHTML = `<p class="error">${err.message}</p>`;
      return;
    }

    resultsBox.innerHTML = '<p class="loading">Checking shipping rates…</p>';
    try {
      const params = new URLSearchParams({
        'shipping_address[zip]':      zip5,
        'shipping_address[country]':  'US',
        'shipping_address[province]': stateAbbrev
      });

      const shopRes = await fetch(`/cart/shipping_rates.json?${params.toString()}`);
      if (shopRes.status === 422) {
        resultsBox.innerHTML = '<p class="no-rates">No shipping options available for this ZIP.</p>';
        return;
      }
      if (!shopRes.ok) throw new Error(`HTTP ${shopRes.status}`);
      const { shipping_rates } = await shopRes.json();
      renderShippingOptions(shipping_rates || []);
    } catch (err) {
      resultsBox.innerHTML = `<p class="error">Error fetching rates: ${err.message}</p>`;
    }
  });

  function renderShippingOptions(rates) {
    if (!Array.isArray(rates) || rates.length === 0) {
      resultsBox.innerHTML = '<p class="no-rates">No shipping rates found.</p>';
      return;
    }
    const ul = document.createElement('ul');
    ul.className = 'shipping-rates-list';
    rates.forEach(rate => {
      const li = document.createElement('li');
      li.className = 'shipping-rate-item';
      li.innerHTML = `
        <span class="rate-name">${rate.name}</span>
        <span class="rate-price">${formatMoney(rate.price)}</span>
      `;
      ul.appendChild(li);
    });
    resultsBox.innerHTML = '';
    resultsBox.appendChild(ul);
  }

  function formatMoney(cents) {
    return `$${cents}`;
  }
});
